import Inspector from './inspector';
const { RichText } = wp.blockEditor;
const staticDefaultImage = 'https://via.placeholder.com/40?text=40';

const Edit = ({ attributes, setAttributes }) => {
  const { cardTitle, cardText, cardButtonText, icon } = attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />
      <div className="ContactUsCards__item">
        <div className="ContactUsCards__item-header">
          <figure className="ContactUsCards__item-icon">
            <img src={icon.src || staticDefaultImage} />
          </figure>

          <RichText
            className="ContactUsCards__item-title"
            tagName="h4"
            value={cardTitle}
            placeholder="Titulo aqui"
            keepPlaceholderOnFocus
            onChange={(cardTitle) => setAttributes({ cardTitle })}
          />
        </div>

        <RichText
          className="ContactUsCards__item-text"
          tagName="p"
          value={cardText}
          placeholder="Texto aqui"
          keepPlaceholderOnFocus
          onChange={(cardText) => setAttributes({ cardText })}
        />

        <RichText
          className="ContactUsCards__item-button"
          tagName="p"
          value={cardButtonText}
          placeholder="Texto aqui"
          keepPlaceholderOnFocus
          onChange={(cardButtonText) => setAttributes({ cardButtonText })}
        />
      </div>
    </>
  );
};

export default Edit;
